import { keys } from '../utils/Object';

interface CookieMap {
  [key: string]: string | undefined;
}

const parseCookies = (cookieString: string): CookieMap => {
  const cookiePairs = cookieString.split(';');
  return cookiePairs.reduce((acc: CookieMap, pair: string) => {
    const [key, value] = pair.split('=');
    acc[key.trim()] = value || '';
    return acc;
  }, {});
};

interface CookieOptions {
  path?: string;
  domain?: string;
  maxAge?: number;
  expires?: Date;
  secure?: boolean;
}

const cookieOptionsMapping = {
  path: 'path',
  domain: 'domain',
  maxAge: 'max-age',
  expires: 'expires',
  secure: 'secure'
};

class Cookies {
  public cookies: CookieMap;

  constructor(cookiesMap: CookieMap) {
    this.cookies = cookiesMap;
  }

  public get(key: string) {
    this.cookies = parseCookies(document.cookie);
    return key in this.cookies ? this.cookies[key] : null;
  }

  public has(key: string) {
    this.cookies = parseCookies(document.cookie);
    return key in this.cookies;
  }

  public set(key: string, value: string, options: CookieOptions = {}) {
    this.cookies[key] = value;
    const cookieOptions = keys(options).map(optionKey => {
      const cookieOptionKey = cookieOptionsMapping[optionKey];
      if (cookieOptionKey !== 'secure') {
        const cookieValue = options[optionKey];
        if (cookieValue instanceof Date) {
          return `${cookieOptionKey}=${cookieValue.toUTCString()}`;
        }
        return `${cookieOptionKey}=${(options[optionKey] || '').toString()}`;
      }
      return 'secure';
    });
    const cookieString = [`${key}=${value}`].concat(cookieOptions);
    if (process.env.NODE_ENV !== 'production') {
      console.log('setting new cookie:', cookieString.join(';'));
    }
    document.cookie = cookieString.join(';');
  }
}

export const cookies = new Cookies(parseCookies(document.cookie));
